import { render, staticRenderFns } from "./sftsumit.vue?vue&type=template&id=32cfb7d4&"
import script from "./sftsumit.vue?vue&type=script&lang=js&"
export * from "./sftsumit.vue?vue&type=script&lang=js&"
import style0 from "./sftsumit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports